import { Injectable } from '@angular/core';

import { BaseService } from 'app/_services/base.service';
import { SettingsService } from 'app/_services/settings.service';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { HoldingSupplier } from './_models/holdingSupplier';
import { HoldingUser } from './_models/holdingUser';
import { SellerOnVacationCreation } from './_models/sellerOnVacationCreation';
import { SellerOnVacation } from './_models/sellerOnVacation';

@Injectable({ providedIn: 'root' })
export class SupportSellerVacationService extends BaseService {
    private _apiSupportUrl: string = `${environment.apiSupport}`;
    private _domain: string = '/sellers';

    constructor(private config: SettingsService, private http: HttpClient) {
        super();
    }

    public endSellerVacation(sellerId: number, substituteSellerId: number): Observable<ApiResponseModel<boolean>> {
        return this.config.executeDelete({ baseUrl: this._apiSupportUrl, url: `${this._domain}/${sellerId}/vacations/${substituteSellerId}` });
    }

    public getSellersOnVacation(): Observable<ApiResponseModel<SellerOnVacation[]>> {
        return this.config.executeGet({ baseUrl: this._apiSupportUrl, url: `${this._domain}/vacations` });
    }

    public getSupplierHoldings(): Observable<ApiResponseModel<HoldingSupplier[]>> {
        return this.config.executeGet({ baseUrl: this._apiSupportUrl, url: `/holdings/suppliers` });
    }

    public getSupplierHoldingsUsers(holdingId: number): Observable<ApiResponseModel<HoldingUser[]>> {
        return this.config.executeGet({ baseUrl: this._apiSupportUrl, url: `/holdings/suppliers/${holdingId}/users` });
    }

    public startSellerVacation(sellerVacation: SellerOnVacationCreation): Observable<ApiResponseModel<boolean>> {
        return this.config.executePost({ baseUrl: this._apiSupportUrl, url: `${this._domain}/${sellerVacation.sellerId}/vacations/${sellerVacation.substituteSellerId}`, body: { holdingId: sellerVacation.holdingId, endDate: sellerVacation.endDate } });
    }
}
